import { HTMLProps, PropsWithChildren } from 'react'

import { createStyles } from 'antd-style'

const useStyles = createStyles(({ token }) => ({
  wrapper: {
    lineHeight: token.lineHeight,
    padding: `${Math.max(
      Math.round(
        ((token.controlHeight - token.fontSize * token.lineHeight) / 2) * 10
      ) /
        10 -
        token.lineWidth,
      3
    )}px 0`
  }
}))

export const PreviewWrapper = ({
  children,
  className,
  ...props
}: PropsWithChildren<HTMLProps<HTMLDivElement>>) => {
  const { cx, styles } = useStyles()

  return (
    <div className={cx(styles.wrapper, className)} {...props}>
      {children}
    </div>
  )
}
